import React from 'react';
import PropTypes from 'prop-types';
import Button from '@material-ui/core/Button';
import Icon from '@material-ui/core/Icon';

const IconButton = ({ size, children, ...props }) => (
  <Button {...props}>
    <Icon
      fontSize={size}
      style={{ color: 'white' }}
    >
      {children}
    </Icon>
  </Button>
);

IconButton.propTypes = {
  children: PropTypes.node.isRequired,
  size: PropTypes.string,
};

IconButton.defaultProps = {
  size: 'default',
};

export default IconButton;
